module.exports = __webpack_public_path__ + "img/schema_tailles_fr.6ae6b332.png";